import { ArrowBack as ArrowBackIcon, Assignment as AssignmentIcon } from '@mui/icons-material';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import type { ParsedWaiverRecord } from '@/apps/engagement-letter-database/store/useWaiverRecord';

interface HeaderPaneProps {
  record: ParsedWaiverRecord;
}

const HeaderPane = ({ record }: HeaderPaneProps) => {
  const navigate = useNavigate();
  return (
    <>
      <Stack direction="row" spacing={2} sx={{ mb: 3, alignItems: 'center' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => void navigate(-1)}>
          Back
        </Button>
        <Box sx={{ flexGrow: 1 }} />
      </Stack>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <AssignmentIcon sx={{ mr: 1, color: 'secondary.main' }} />
        <Typography variant="h4">{record.clientName || record.adverseClientName || 'Waiver Record'}</Typography>
      </Box>
      {record.matterNumber && (
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Matter Number: {record.matterNumber}
        </Typography>
      )}
      <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
        <Chip label="Waiver Letter" color="secondary" />
        {record.multipleWaivers === 'Yes' && <Chip label="Multiple Waivers" color="info" />}
      </Stack>
    </>
  );
};

export default HeaderPane;
